import { useState } from 'react';
import { EditorState, convertFromRaw, convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';

const parseEditorContent = (payload) => {
  let contentState = null;
  try {
    contentState = EditorState.createWithContent(convertFromRaw(JSON.parse(payload)))
  } catch (e) {
    contentState = EditorState.createEmpty();
  }

  return contentState;
}

const handleInitialValue = (initialRawData) => {
  if (initialRawData) {
    return parseEditorContent(initialRawData)
  } else {
    return EditorState.createEmpty()
  }
}

export default function useDraftEditor(initialRawData) {
  const [editorState, setEditorState] = useState(() => handleInitialValue(initialRawData));

  const editorStateToHtml = (payload) =>
    draftToHtml(convertToRaw(payload.getCurrentContent()));

  const editorStateToJsonString = (payload) =>
    JSON.stringify(convertToRaw(
      (payload && payload.getCurrentContent()) || editorState.getCurrentContent()
    ));

  const jsonStringToEditorState = (payload) =>
    parseEditorContent(payload);

  return {
    editorState,
    setEditorState,
    editorStateToJsonString,
    jsonStringToEditorState,
    editorStateToHtml
  }
}